import React, { useState, useEffect } from 'react';
import './Amenities.css';

const Amenities = () => {
  const [featuredItem, setFeaturedItem] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const amenities = [
    {
      id: 1,
      title: "Wellness & Rejuvenation",
      subtitle: "Where nature heals and time slows down.",
      imageId: "wellness"
    },
    {
      id: 2,
      title: "Nature Immersion Experiences",
      subtitle: "Step into stillness, surrounded by living earth.",
      imageId: "nature-immersion"
    },
    {
      id: 3,
      title: "Culture & Community",
      subtitle: "Rooted in connection, elevated by experience.",
      imageId: "culture-community"
    },
    {
      id: 4,
      title: "Recreation & Fitness",
      subtitle: "Move freely, live fully, breathe deeply.",
      imageId: "recreation-fitness"
    },
    {
      id: 5,
      title: "Eco-Living & Sustainability",
      subtitle: "Luxury that gives back to the land.",
      imageId: "eco-living"
    }
  ];

  const amenityImages = [
    {
      id: "wellness",
      src: "/aminites/wellness/bamboo-forest-yoga-stockcake.jpg",
      alt: "Wellness & Rejuvenation",
      caption: "Find stillness in our open-air yoga pavilion surrounded by native greens and fresh mountain air."
    },
    {
      id: "nature-immersion",
      src: "/aminites/nature immersion/image18_fantasy-backyard-ideas_fantasy-flower-arches.jpg",
      alt: "Nature Immersion Experiences",
      caption: "Explore scenic trails and immerse yourself in pristine natural landscapes."
    },
    {
      id: "culture-community",
      src: "/aminites/culture and community/1638248938.jpg",
      alt: "Culture & Community",
      caption: "Connect and unwind in shared lifestyle spaces designed for community."
    },
    {
      id: "recreation-fitness",
      src: "/aminites/recreation & fitness/e6c791daf1b9e907f97ba13fd64303f4.jpg",
      alt: "Recreation & Fitness",
      caption: "Stay active with modern fitness facilities and recreational spaces."
    },
    {
      id: "eco-living",
      src: "/aminites/eco living/birds-eye-view-solar-scape-structure.jpg",
      alt: "Eco-Living & Sustainability",
      caption: "Embrace sustainable living with eco-friendly practices and green technologies."
    }
  ];

  // Auto-advance with pause support (robust in StrictMode)
  useEffect(() => {
    if (isPaused) return;
    const timer = setTimeout(() => {
      setFeaturedItem((prev) => (prev + 1) % amenities.length);
    }, 4000);
    return () => clearTimeout(timer);
  }, [featuredItem, isPaused, amenities.length]);

  const handleAmenityHover = (index) => {
    setFeaturedItem(index);
  };

  const handleAmenityLeave = () => {
    // keep current selection, resume auto via effect
  };

  const handlePrevious = () => {
    setFeaturedItem((prev) => (prev - 1 + amenities.length) % amenities.length);
  };

  const handleNext = () => {
    setFeaturedItem((prev) => (prev + 1) % amenities.length);
  };

  return (
    <section 
      id="amenities" 
      className="amenities"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Vector.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="amenities-content">
        <div className="amenities-left">
          <h2>Highlight Amenities</h2>
          {/* Mobile-only current amenity heading */}
          <div className="amenities-mobile-heading">
            <h3 className="amenities-mobile-title">{amenities[featuredItem]?.title}</h3>
            {amenities[featuredItem]?.subtitle && (
              <p className="amenities-mobile-sub">{amenities[featuredItem].subtitle}</p>
            )}
          </div>
          <p className="amenities-subtitle">DISCOVER THE DIFFERENCE</p>
          <div className="amenities-list">
              {amenities.map((amenity, index) => (
                <div 
                  key={amenity.id} 
                  className={`amenity-item ${featuredItem === index ? 'featured' : ''}`}
                  data-image={amenity.imageId}
                  onMouseEnter={() => handleAmenityHover(index)}
                  onMouseLeave={handleAmenityLeave}
                >
                  <div className="amenity-check">{amenity.id}</div>
                  <div className="amenity-text">
                    <h3>{amenity.title}</h3>
                    <p>{amenity.subtitle}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="amenities-right">
            <div 
              className="amenities-image-container"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
              onTouchStart={() => setIsPaused(true)}
              onTouchEnd={() => setIsPaused(false)}
            >
              <button 
                className="amenity-arrow amenity-arrow-left" 
                onClick={handlePrevious}
                onPointerDown={(e)=>{ e.preventDefault(); setIsPaused(true); handlePrevious(); }}
                aria-label="Previous amenity"
              >
                ‹
              </button>
              {amenityImages.map((image, index) => (
                <div 
                  key={image.id}
                  className={`amenity-image ${featuredItem === index ? 'active' : ''}`}
                  id={image.id}
                >
                  <img src={image.src} alt={image.alt} />
                  {image.caption && (
                    <div className="image-caption">{image.caption}</div>
                  )}
                </div>
              ))}
              <button 
                className="amenity-arrow amenity-arrow-right" 
                onClick={handleNext}
                onPointerDown={(e)=>{ e.preventDefault(); setIsPaused(true); handleNext(); }}
                aria-label="Next amenity"
              >
                ›
              </button>
            </div>
          </div>
        </div>
    </section>
  );
};

export default Amenities;
